
    import { mapGetters } from 'vuex';

    export default {
        name: 'HistogramMinMax',

        data() {
            return {};
        },

        computed: {
            ...mapGetters('job', {
                $_marketPay: 'marketPay',
                $_pay: 'pay',
            }),
            pMinLabel() {
                return ((this.$_pay.payMin < this.$_marketPay.payMin) ? this.$_pay.payMinShortLabel : this.$_marketPay.payMinShortLabel);
            },
            pMaxLabel() {
                return ((this.$_pay.payMax > this.$_marketPay.payMax) ? this.$_pay.payMaxShortLabel : this.$_marketPay.payMaxShortLabel);
            },
        },

        methods: {},
    };
